import { URLUtils } from '@utils/URLUtils';
import { IMenuTabModel, IMenusModel, MenuTabModel } from '@models/AppMenus';
import { Observable, BehaviorSubject } from 'rxjs';
import { WebService } from '@services/web.service';
import { Injectable } from '@angular/core';
import { IAPIResponse } from '@api/AbstractAPI';

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    private menus: IMenusModel[];

    public Menus: Observable<IMenusModel[]>;

    private selectedMenu: IMenusModel;

    private menufinded: { path: string, menuData: IMenusModel } = { path: null, menuData: null };

    private static readonly FIXED_PATHS = ['/manage', '/view', '/add', '/edit', '/details', '/list', '/import'];

    private static readonly PATH_ALIASES: [string, string][] = [
        ['/campaigns/draft', '/campaigns/list'],
    ];

    private menuMap = new Map<string, IMenusModel>();

    private menusBehaviorSubject: BehaviorSubject<IMenusModel[]>;

    private plaforms: any[];

    constructor(
        private WebService: WebService
    ) {

        this.menusBehaviorSubject = new BehaviorSubject<IMenusModel[]>(this.menus);

        this.Menus = this.menusBehaviorSubject.asObservable();

        this.Menus.subscribe(menus => {

            this.menus = menus;
        });
    }

    async Init() {

        this.menus = [];
        this.menuMap.clear();

        await this.GetPlatformList();

        await this.getMenus();

        // if (environment.production == false)
        // 	await this.getMenuListModules();

        // console.log(this.menus);

    }

    private async getMenus(): Promise<IMenusModel[]> {

        if (this.menus?.length > 0) return Promise.resolve(this.menus);

        const result = await this.WebService.GetNavigationList();

        this.menus = result?.Result || [];

        this.menusSetParams(this.menus);

        this.menusBehaviorSubject.next(this.menus);

        return this.menus;

    }

    private menusSetParams(data: IMenusModel[]) {

        data.forEach(el => {

            if (el.NavigationPath) {

                const url = new URL(window.location.origin + (el?.NavigationPath[0] != "/" ? ("/" + el?.NavigationPath) : el?.NavigationPath));

                const search = Object.fromEntries(url.searchParams as any);

                let pathname = url?.pathname || '';

                // Same route shared by several menus: IdContentType is the differentiator (last path segment). 1 = default (Undefined), not appended
                if (pathname && el.IdContentType && el.IdContentType != 1 && !pathname.endsWith(`/${el.IdContentType}`))
                    pathname = pathname.replace(/\/$/, '') + `/${el.IdContentType}`;

                el['NavigationPath'] = pathname;
                el['QueryParams'] = search || '';

                if (el.NavigationPath) {
                    this.menuMap.set(el.NavigationPath, el);
                }
            }

            if (el.Children.length > 0)
                this.menusSetParams(el.Children);

        });
    }

    public async GetMenus() {

        return await this.getMenus();
    }

    public SetMenuSelected(menu: IMenusModel) {

        this.selectedMenu = menu || null;

        this.WebService.SetMenu(this.selectedMenu?.Id || null);
    }

    /**
     * 
     * @param path 
     * @returns 
     */
    public SetMenuByPath(path: string = null): boolean {

        path = URLUtils.RemoveLanguageReference(path);

        this.selectedMenu = this.findMenu(path);

        console.log(path, this.selectedMenu);

        this.WebService.SetMenu(this.selectedMenu?.Id || null);

        return this.selectedMenu ? true : false;

    }

    /**
     * 
     * @param path 
     */
    public GetMenuByPath(path: string = null): IMenusModel {

        path = URLUtils.RemoveLanguageReference(path);

        return this.findMenu(path);


    }

    /**
     * 
     * @param path 
     * @returns 
     */
    public GetPermissionsMenuByPath(path: string = null, idTAB: number = null): number[] {

        // console.log(path, idTAB);

        path = URLUtils.RemoveLanguageReference(path);

        const menu: IMenusModel = this.findMenu(path);

        const operations: number[] = idTAB && menu?.Children?.length > 0 ? menu.Children.find(el => el.NavigationPath && el.QueryParams?.id && Number(el.QueryParams?.id) == idTAB)?.PermittedOperationList || [] : menu?.PermittedOperationList || [];

        // console.log(idTAB, operations);

        return operations || [];

    }

    private findMenu(path: string): IMenusModel | null {

        path = path.split('?')[0];

        if (path === this.menufinded?.path) return this.menufinded?.menuData;

        if (this.menuMap.size === 0) return null;

        let found = this.menuMap.get(path) ?? null;

        if (!found) {
            const suffix = MenuService.FIXED_PATHS.find(p => path.includes(p));
            const stripped = suffix ? path.split(suffix)[0] : path;

            if (stripped !== path) {
                found = this.menuMap.get(stripped) ?? null;

                if (!found) {
                    found = this.menuMap.get(stripped + suffix) ?? null;
                }

                if (!found) {
                    const parts = stripped.split('/');
                    if (parts.length > 3) {
                        parts.pop();
                        found = this.menuMap.get(parts.join('/')) ?? null;
                    }
                }
            }
        }

        if (!found) {
            const alias = MenuService.PATH_ALIASES.find(([prefix]) => path.startsWith(prefix));
            if (alias) found = this.menuMap.get(alias[1]) ?? null;
        }

        if (found) this.menufinded = { path, menuData: found };

        return found;
    }

    /**
     * 
     * @param idPlatform 
     * @returns 
     */
    public async GetMenuList(idPlatform?: number): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetMenuList(idPlatform);

        return response;

    }

    /**
     * 
     * @param idMenu 
     * @returns 
     */
    public async GetMenu(idMenu: number): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetMenu(idMenu);

        return response;

    }

    /**
     * 
     * @param data 
     * @returns 
     */
    public async SaveMenu(data): Promise<IAPIResponse<any>> {

        const response = await this.WebService.SaveMenu(data);

        return response;

    }

    /**
     * 
     * @param menus 
     * @returns 
     */
    public async ChangePositionMenu(menus: { Id: string, Position: number, IdParent?: string }[]): Promise<IAPIResponse<any>> {

        const response = await this.WebService.ChangePositionMenu(menus);

        return response;

    }

    /**
     * 
     * @param idMenu 
     * @returns 
     */
    public async DeleteMenu(idMenu: number): Promise<IAPIResponse<any>> {

        const response = await this.WebService.DeleteMenu(idMenu);

        return response;

    }

    public async GetPlatformList(): Promise<any[]> {

        if (this.plaforms && this.plaforms.length > 0) return Promise.resolve(this.plaforms);

        const response = await this.WebService.GetPlatformList();

        this.plaforms = response?.Result || [];

        return this.plaforms;

    }

    /**
     * 
     * @returns 
     */
    public async GetMenuListModules(): Promise<any[]> {

        const response = await this.WebService.GetMenuListModules();

        const data = response?.Result || [];

        // console.log(data);

        return data;

    }


    /**
     * 
     * @param idModule 
     * @param idMenu 
     * @returns 
     */
    public async GetOperationList(idModule?: string, idMenu?: string): Promise<any[]> {

        const response = await this.WebService.GetOperationList(idModule, idMenu);

        const data = response?.Result || [];

        // console.log(data);

        return data;

    }

    /**
     * 
     * @returns 
     */
    public async GetMenuTabList(): Promise<IMenuTabModel[]> {

        const response = await this.WebService.GetMenuTabList();

        const data = (response?.Result || []).map(it => new MenuTabModel(it)).sort((a, b) => (+(a?.NavigationPosition) > +(b?.NavigationPosition) ? -1 : 1) * -1);

        // console.log(data);

        return data;

    }

    /**
     * 
     * @param idParent 
     * @param idModule 
     * @returns 
     */
    public async GetSimpleMenuListPermissions(idParent?: string, idModule?: number): Promise<any> {

        const response = await this.WebService.GetSimpleMenuListPermissions(idParent, idModule);

        return response;

    }

    /**
     * 
     * @param id 
     * @returns 
     */
    public async GetRoleUserPermissionTemplate(id: string): Promise<any> {

        const response = await this.WebService.GetRoleUserPermissionTemplate(id);

        return response;

    }

    public GetMenuTitle(): string {

        return this.menufinded?.menuData?.Name || "";
    }
}
